<template>
    <div class="report">                        
        <div class="table-main">
            <div class="report-table-wrapper">
                <div class="table-header">                                
                        <h4 class="table-header-title">
                            {{ name }}
                        </h4>                                    
                </div>
                <div class="tables-list">                                
                    <CCTable v-if="hasData"
                        :header="tableHeader"
                        :body="tableBody"
                        :footer="tableFooter"
                        :namespace="name"
                    />                                    
                    <template v-if="isLoading">
                        <div class="table-no-results">
                            <Spinner color="#797979" size="20px"></Spinner>
                        </div>
                    </template>
                    <template v-else-if="!hasData">
                        <div class="table-no-results">There are no results with these filters.</div>
                    </template>
                </div>                                
                <div class="table-wrapper-bottom">
                    <div class="action-button-wrapper">
                        <!--<button @click="exportReportAsCSV()">Export as CSV</button>-->
                    </div>                                
                </div>
            </div>
        </div>
    </div>
</template>


<style lang="scss">
    tfoot .yahoo-arbitrage-difference,
    tbody .yahoo-arbitrage-difference{
        color: #357e33;
        font-weight: bold;
    }

    tfoot .yahoo-arbitrage-difference-negative,
    tbody .yahoo-arbitrage-difference-negative{
        color: #fb0006;
    }
</style>
<style lang="scss" scoped>
    .report {
        height: auto;
    }

    .table-main {
        display: flex;
        max-width: 100%;
        height: 100%;
    }

    .table-wrapper {
        height: auto !important;
    }

    .table {
        width: 100%;
    }

    .report-table-wrapper {
        width: 100%;
        display: block;
        background-color: #fff;
        padding: 20px 20px 0px 20px;

        & > .table-header {
            margin-bottom: 45px;
        }

        & > .tables-list {
            display: flex;
            flex-direction: row;
            width: 100%;
            /*max-height: 360px;*/
        }

        @include mobile-only {
            padding: 0px;
        }
    }

    .table-no-results {
        margin-top: 20px;
        margin-bottom: 20px;
        display: flex;
        justify-content: center;
        justify-self: center;
        justify-items: center;
        width: 100%;
    }

    .table-wrapper-bottom {
        display: grid;
        grid-template-columns: 1fr 1fr;
        background-color: #fff;
        margin-bottom: 15px;
        padding-bottom: 15px;
    }
</style>

<script>
    import 'vue-loaders/dist/vue-loaders.css';

    import CCTable from '@/components/common/table_v3/Table';
    import Builder from '@/components/common/table_v3/Builder';
    import Cell from '@/components/common/table_v3/Cell';

    import {formatNumbers, roundValue} from '@/helpers/format';

    import tableMixins from '@/components/common/table_v3/mixin/external.mixin';

    import { LineScalePulseOutRapidLoader as Spinner } from 'vue-loaders';
    import lodash from 'lodash';

    export default {

        name: "target-report-table",
        components: {
            CCTable,
            Spinner
        },
        mixins : tableMixins,
        props : {
            name: {
                type: String,
                required: true
            },
            columns: {
                type: Array,
                required: true
            },
            body: {
                type: Array,
                required: true
            },
            footer: {
                type: Array,
                required: true
            },
            status: {
                type: String,
                required: true
            },
        },
        data(){  
            return {
                fixedColumns: []
            }          
        }, 
        
        computed : {
            tableHeader: function(){
                let builder = new Builder;        
                let header = builder.header({
                    columns : this.tableColumns,
                    fixedColumns: this.fixedColumns
                });

                //console.log(this.tableStoreNamespacePrefix, 'tablev2_HEADER', header);

                return header;
            },

            tableBody: function(){
                let builder = new Builder;
  
                let body  = builder.body(this.body);
                body.rows = this.modifyRows(body.rows)

                return body;
            },

            tableFooter: function(){
                let builder = new Builder;
                let footer = builder.footer(this.footer);
                footer.rows = this.modifyRows(footer.rows);
                return footer;
            },

            tableColumns: function(){

                let self     = this;
                let builder  = new Builder;
                let list     = lodash.cloneDeep(this.columns);
                let columns  = [];

                for( let key in list) {

                    let column = list[key];

                    column.id    = column.id    || column.field;
                    column.title = column.title || column.label;

                    column = builder.column(column);

                    //column.sortable   = true;
                    //column.comparable = false;
                    //column.fixable    = false;

                    columns[key] = column;
                }

                this.registerFixClickCallback(columns, column => {
                    let index = this.fixedColumns.indexOf(column.id);
                    if(index === -1) {
                        this.fixedColumns.push(column.id);
                    } else {
                        this.fixedColumns.splice(index, 1);
                    }
                });
                //this.registerSortClickCallback(columns);
                //this.registerCompareClickCallback(columns);    
                
                return columns;
            },
     
            hasData: function() {
                return lodash.isArray(this.body) && this.body.length > 0;
            },

            isLoading: function() {
                return this.status === 'loading';
            },

            isLoaded: function() {
                return this.status === 'loaded';
            }
        },

        methods : {
            modifyRows(rows) {
                let builder  = new Builder;
                return _.map(rows, row => {
                    for( let columnId in row.cells ) {
                        if( row.cells.hasOwnProperty('difference') ) {
                            row.cells['difference'].map(cell => {
                                if( cell.value < 0 ) {
                                    cell.meta = builder.meta({
                                        attributes: {
                                            classes : ['yahoo-arbitrage-difference-negative']
                                        }
                                    })
                                }
                                
                            })
                        }

                        _.map(row.cells, columnCells => _.map(columnCells, cell => {
                                if( _.isNumber(cell.value) )  {
                                    cell.value = formatNumbers(cell.value)
                                }
                            })
                        );
                    }
                    return builder.row(row);
                });
            }
        }


    }
</script>


// WEBPACK FOOTER //
// src/components/reports/targetReport/table.vue